
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {baseUrl, dashboardLimit, feedProductType, usageType, fuelType} from "../../../comman/config.js";
import Loader from "../../../comman/Loader";
import { PencilIcon, XCircleIcon } from '@heroicons/react/outline';
import {DateFilter} from "../../../comman/DateFilter.js";
import { useNavigate, Link } from 'react-router-dom';
import Pagination from "react-js-pagination";

function Dashboard() {

    const [expenseList, setExpenseList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [totalExpense, setTotalExpense] = useState(0);
    const [productionList, setProductionList] = useState([]);
    const [productionPage, setProductionPage] = useState(1);
    const [productionTotalItem, setProductionTotalItem] = useState(0);

    const [otherIncomeList, setOtherIncomeList] = useState([]);
    const [otherIncomePage, setOtherIncomePage] = useState(1);
    const [otherIncomeTotalItem, setOtherIncomeTotalItem] = useState(0);



    useEffect(() => {
        if(fromDate && toDate){
            getExpenseDetail();
        }
    }, [page, fromDate,toDate]);

    useEffect(() => {
        if(fromDate && toDate){
            getProductionDetail();
        }
    }, [productionPage, fromDate,toDate]);

    useEffect(() => {
        if(fromDate && toDate){
            getOtherIncomeDetail();
        }
    }, [otherIncomePage, fromDate,toDate]);

    const handlePageChange  = (pageNumber) => {
        setPage(pageNumber);
    }
    const handleProductionPageChange = (pageNumber) => {
        setProductionPage(pageNumber);
    }

    const handleOtherIncomePageChange = (pageNumber) => {
        setOtherIncomePage(pageNumber);
    }

    const getExpenseDetail = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/admin/agriculture/dashboard/expense_list?page=${page}&limit=${dashboardLimit}&fromDate=${fromDate}&toDate=${toDate}`);
        setPopupOpen(false);
        const detailList = response.data.data;
        setTotalExpense(response.data.totalExpense ?? 0);
        setExpenseList(detailList);
        setTotalItem(response.data.totalItem);
    }

    const getProductionDetail = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/admin/agriculture/dashboard/production_list?page=${productionPage}&limit=${dashboardLimit}&fromDate=${fromDate}&toDate=${toDate}`);
        setPopupOpen(false);
        setProductionList(response.data.data);
        setProductionTotalItem(response.data.totalItem);
    }

    const getOtherIncomeDetail = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/admin/agriculture/dashboard/other_income_list?page=${otherIncomePage}&limit=${dashboardLimit}&fromDate=${fromDate}&toDate=${toDate}`);
        setPopupOpen(false);
        setOtherIncomeList(response.data.data);
        setOtherIncomeTotalItem(response.data.totalItem);
    }
    

    const handelFilterChange= (fromDate, toDate, clear, today) => {
        if(clear){
            setFromDate(today);
            setToDate(today); 
        }else{
            setFromDate(fromDate);
            setToDate(toDate); 
        }
        
    };

    const getProductName = (item) => {
       
        if(item.type == "salary" || item.type == "other"){
            return item.name;
        }else if(item.type == "feed"){
            const type = feedProductType.find((val) => val.value == item.product_type)?.label ?? "";
            return `${item.name} ${type ? `(${type})` : ""}`;
        }else if(item.type == "fuel"){
            const fuel = fuelType.find((val) => val.value == item.name)?.label ?? "";
            const type = usageType.find((val) => val.value == item.product_type)?.label ?? "";
            return `${fuel} ${type ? `(${type})` : ""}`;
        }
    }


    return (
        
        <div className="p-4">
            {popupOpen && (
                     <Loader /> 
                ) }
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Dashboard</h1>
              
            </div>
            
            <div className="relative overflow-x-auto ">
    <DateFilter handleFilterChange={handelFilterChange} />
    <div className="mt-4 px-2 mb-4">
        <h3><strong>Total Expense: </strong>{parseFloat(totalExpense ?? 0).toFixed(2)}</h3>
    </div>
    <div className="flex justify-between">
      
        <div className="w-1/2 px-2">
            <div className="bg-white border rounded-lg shadow p-4 dark:bg-gray-800 dark:border-gray-700">
                <strong>Expense</strong>
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 mt-2">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" className="px-6 py-3 border">Date</th>
                            <th scope="col" className="px-6 py-3 border">Name</th>
                            <th scope="col" className="px-6 py-3 border">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {expenseList.map((item, index) => (
                            <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{item.date}</th>
                                <td className="px-6 py-4">{getProductName(item)}</td>
                                <td className="px-6 py-4">{item.price}</td> 

                            </tr>
                        ))}
                    </tbody>
                </table>
                {totalItem > dashboardLimit && (<Pagination
              activePage={page}
              itemsCountPerPage={dashboardLimit}
              totalItemsCount={totalItem}
              pageRangeDisplayed={5}
              onChange={handlePageChange.bind(this)}
            />)}
            </div>
        </div>

        <div className="w-1/2 px-2">
            <div className="bg-white border rounded-lg shadow p-4 dark:bg-gray-800 dark:border-gray-700">
                <strong>Production</strong>
                
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 mt-2">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr >
                            <th scope="col" className="px-6 py-3 border">Date</th>
                            <th scope="col" className="px-6 py-3 border">Company</th>
                            <th scope="col" className="px-6 py-3 border">Name</th>
                            <th scope="col" className="px-6 py-3 border">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {productionList.map((item, index) => (
                            <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{item.date}</th>
                                <td className="px-6 py-4">{item.company_name}</td>
                                <td className="px-6 py-4">{item.name}</td>
                                <td className="px-6 py-4">{item.price}</td> 
                                
                            </tr>
                        ))}
                    </tbody>
                </table>
                {productionTotalItem > dashboardLimit && (<Pagination
              activePage={productionPage}
              itemsCountPerPage={dashboardLimit}
              totalItemsCount={productionTotalItem}
              pageRangeDisplayed={5}
              onChange={handleProductionPageChange.bind(this)}
            />)}
            </div>
        </div>
        
    </div>
    <div className='row my-10'>
    <div className=" px-2">
            <div className="bg-white border rounded-lg shadow p-4 dark:bg-gray-800 dark:border-gray-700">
                <strong>Other Income</strong>
                
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 mt-2">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr >
                            <th scope="col" className="px-6 py-3 border">Date</th>
                            <th scope="col" className="px-6 py-3 border">Item</th>
                            <th scope="col" className="px-6 py-3 border">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {otherIncomeList.map((item, index) => (
                            <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{item.date}</th>
                                <td className="px-6 py-4">{item.name}</td>
                                <td className="px-6 py-4">{item.price}</td> 
                                
                            </tr>
                        ))}
                    </tbody>
                </table>
                {otherIncomeTotalItem > dashboardLimit && (<Pagination
              activePage={otherIncomePage}
              itemsCountPerPage={dashboardLimit}
              totalItemsCount={otherIncomeTotalItem}
              pageRangeDisplayed={5}
              onChange={handleOtherIncomePageChange.bind(this)}
            />)}
            </div>
        </div>
    </div>
    
</div>

            
        </div>
        
  );
}

export default Dashboard;